import React from "react";
import Button from "@material/react-button";
import "./style.css";

import { __ } from "@wordpress/i18n";

const SaveButton = () => (
	<div id="eb-save-admin-options">
		<Button raised>{__("Save", "essential-blocks")}</Button>
	</div>
);

export default SaveButton;
